import React from 'react';
import { Dialog } from '@material-ui/core';
import axios from 'axios';
import { useAuth } from '../../../context/auth';
import {
    StyledDialogContent,
    DialogTitle,
    DialogDescription,
    SaveButton,
    CloseButton,
    FlexWrapper
} from '../Dialogs.styles';
import { VerificationProps } from './Verification.interface';

export function Verification({ open, setOpen }: VerificationProps) {
    const { authToken } = useAuth();
    const sendVerificationEmail = () => {
        axios.post('/api/v2/accounts/verification/create-new-link/', {}, {headers: { DTOKEN: `${authToken}`}}).then(() => {
            setOpen(false);
        })
    }
    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            fullWidth
        >
            <StyledDialogContent>
                <DialogTitle>You are yet to confirm your email address!</DialogTitle>
                <DialogDescription>In order to perform this action, please check your email and click on the link to verify your account.</DialogDescription>
                <FlexWrapper>
                    <CloseButton onClick={() => setOpen(false)}>Close</CloseButton>
                    <SaveButton onClick={sendVerificationEmail}>Resend confirmation email</SaveButton>
                </FlexWrapper>
            </StyledDialogContent>
        </Dialog>
    )
}
